import React, { useState } from "react";


const Formb = () => {
    const [name, setName] = useState('');
    const [fullName, setFullName] = useState('');

    const [name2, setName2] = useState('');
    const [fullName2, setFullName2] = useState('');

    const inputEvent = (event) => {
        //console.log(event.target.value);
        setName(event.target.value);
    }
    const inputEvent2 = (event) => {
        //console.log(event.target.value);
        setName2(event.target.value);
    }
    const onSubmit = (event) => {
        event.preventDefault();
        setFullName(name);
        setFullName2(name2);
    }
    return (
        <>
            <div>
                <form onSubmit={onSubmit}>
                    <h1>Hello {fullName} {fullName2}</h1>
                    <input type="text" className="form-control" placeholder="Enter your name" onChange={inputEvent} value={name} />
                    <input type="text" className="form-control" placeholder="Enter your name" onChange={inputEvent2} value={name2} />
                    <button type="submit" className="btn btn-primary">Submit</button>
                </form>
            </div>
        </>
    )
}

export default Formb;